module.exports = __webpack_public_path__ + "media/images/features/7/schedule-1-17e552a33619d438c9c3360ae873ef79.jpg";